export default {
  name: 'en',
  m: {
    table: {
      menuTitle: 'Action',
      preview: 'Preview',
    },
    dialog: {
      cancelText: 'Cancel',
      confirmText: 'Confirm',
    },
    search: {
      searchBtnText: 'Search',
      resetBtnText: 'Reset',
      expandBtn: 'Expand',
      colBtn: 'Collapse',
    },
    crud: {
      addBtnText: 'Add',
      editBtnText: 'Edit',
      delBtnText: 'Delete',
      addDialogTitle: 'Add',
      editDialogTitle: 'Edit',
      viewDialogTitle: 'View',
      dialogSaveBtnText: 'Save',
      dialogCancelBtnText: 'Cancel',
    },
  },
}
